/*
 * Adds the bottom-left add to cart icon to product cards that Searchspring renders
 * client side. Cards rendered by snippets/card-product.liquid already ship the
 * button in the markup and carry data-product-id, so they are skipped here.
 *
 * Rather than rebuilding the cart request, the icon proxies the click through to the
 * quick add control Searchspring already renders in the same card. That keeps the
 * variant handling, the "Choose options" redirect, the cart drawer and Searchspring's
 * own add-to-cart tracking intact.
 */
(function () {
  if (window.__cardMediaAtcInit) return;
  window.__cardMediaAtcInit = true;

  var CARD_SELECTOR = '.product-card-wrapper';
  var SOURCE_SELECTOR = '.quick-add:not(.image-overlay-atc-wrapper) .quick-add__submit';
  var SOURCE_WAIT_MS = 3000;
  var SOURCE_POLL_MS = 100;

  // button -> { source, observer }. Searchspring re-renders its quick add markup, so the
  // source button can be swapped out from under us and has to be re-bound.
  var bindings = new WeakMap();
  var template = null;

  function getTemplate() {
    if (template === null) template = document.getElementById('CardMediaAtcTemplate') || false;
    return template;
  }

  function findSource(card) {
    return card.querySelector(SOURCE_SELECTOR);
  }

  function setLoading(button, isLoading) {
    var spinner = button.querySelector('.loading-overlay__spinner');
    button.classList.toggle('loading', isLoading);
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    if (spinner) spinner.classList.toggle('hidden', !isLoading);
  }

  function mirror(button, source) {
    var inCart = source.classList.contains('see_in_cart--true');
    var label = button.querySelector('.card-media-atc__label');
    var text = inCart
      ? button.getAttribute('data-label-in-cart') || 'See In Cart'
      : button.getAttribute('data-label-add') || 'Add to cart';

    button.classList.toggle('see_in_cart--true', inCart);
    if (button.getAttribute('aria-label') !== text) button.setAttribute('aria-label', text);
    // Guarded because a redundant write would wake the document observer every time.
    if (label && label.textContent !== text) label.textContent = text;

    setLoading(button, source.classList.contains('loading'));
  }

  function bind(button, source) {
    var current = bindings.get(button);
    if (current && current.source === source) return;
    if (current) current.observer.disconnect();

    var observer = new MutationObserver(function () {
      mirror(button, source);
    });
    observer.observe(source, { attributes: true, attributeFilter: ['class'] });
    bindings.set(button, { source: source, observer: observer });

    mirror(button, source);
  }

  function fallbackUrl(card) {
    var link = card.querySelector('.card__media a[href], a.full-unstyled-link[href]');
    return link ? link.href : null;
  }

  /* Searchspring only renders its quick add a second after the card itself, so a very
     early click waits for it before giving up and sending the shopper to the product. */
  function activate(button, card) {
    if (button.classList.contains('loading')) return;

    var source = findSource(card);
    if (source) {
      bind(button, source);
      source.click();
      return;
    }

    setLoading(button, true);

    var waited = 0;
    var timer = setInterval(function () {
      var found = findSource(card);
      waited += SOURCE_POLL_MS;

      if (found) {
        clearInterval(timer);
        setLoading(button, false);
        bind(button, found);
        found.click();
      } else if (waited >= SOURCE_WAIT_MS) {
        clearInterval(timer);
        setLoading(button, false);
        var url = fallbackUrl(card);
        if (url) window.location.href = url;
      }
    }, SOURCE_POLL_MS);
  }

  function inject(card, media) {
    var tpl = getTemplate();
    if (!tpl) return null;

    var wrapper = tpl.content.firstElementChild.cloneNode(true);
    var button = wrapper.querySelector('.card-media-atc');
    if (!button) return null;

    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      activate(button, card);
    });

    media.appendChild(wrapper);
    return wrapper;
  }

  function enhance(card) {
    // Cards rendered by card-product.liquid carry their own button and form.
    if (card.hasAttribute('data-product-id')) return;

    var media = card.querySelector('.card__media');
    if (!media) return;

    var wrapper = media.querySelector('.card-media-atc-wrapper--js');
    if (!wrapper) {
      if (card.classList.contains('sold-out--product')) return;
      wrapper = inject(card, media);
      if (!wrapper) return;
    }

    var button = wrapper.querySelector('.card-media-atc');
    if (!button) return;

    var source = findSource(card);
    if (source) bind(button, source);
  }

  function scan() {
    document.querySelectorAll(CARD_SELECTOR).forEach(enhance);
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      scan();
    }, 120);
  }

  function start() {
    scan();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
